/**
 * Sport landing quiz ("How risky is your surf?"), Typeform-style: one screen at a time.
 * Progress is rendered per question in Liquid ("02 / 04" + dots), not here.
 * Markup: sections/sport-quiz.liquid — [data-sport-quiz] with [data-quiz-step] panels
 * (intro, one per question, result) and one [data-quiz-profile] panel per result.
 *
 * Scoring: each answer gives one point to its data-profile; most points wins,
 * ties go to the profile listed first. Answers are ordered lowest → highest risk,
 * so data-index / (answer count - 1) is that question's risk (0–1). The average is
 * the exposure gauge; each question is one bar in the result chart (data-factor).
 *
 * Keyboard (when the quiz is in view): Enter starts, A–D pick an answer.
 * Analytics: PostHog events without personal data (sport, profile, exposure only).
 */
(function () {
  function track(event, props) {
    try {
      if (window.posthog && typeof window.posthog.capture === 'function') {
        window.posthog.capture(event, props || {});
      }
    } catch (e) {}
  }

  function levelOf(value) {
    if (value < 0.34) return 0;
    if (value < 0.67) return 1;
    return 2;
  }

  function inView(el) {
    var r = el.getBoundingClientRect();
    return r.top < window.innerHeight * 0.6 && r.bottom > window.innerHeight * 0.4;
  }

  function init(root) {
    if (root.dataset.sportQuizReady) return;
    root.dataset.sportQuizReady = 'true';

    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-quiz-step]'));
    var questions = steps.filter(function (s) {
      return s.dataset.quizStep === 'question';
    });
    var resultStep = root.querySelector('[data-quiz-step="result"]');
    var profiles = Array.prototype.slice.call(root.querySelectorAll('[data-quiz-profile]'));
    var sport = root.dataset.sport || '';
    var answers = [];
    var current = 0;
    var locked = false;

    function show(index, focus) {
      current = index;
      steps.forEach(function (step, i) {
        var active = i === index;
        step.hidden = !active;
        step.classList.toggle('is-active', active);
      });

      if (focus) {
        var target = steps[index].querySelector('.sport-quiz__question, .sport-quiz__title');
        if (target) target.focus({ preventScroll: true });
        var top = root.getBoundingClientRect().top;
        if (top < -40 || top > window.innerHeight * 0.3) {
          window.scrollTo({ top: top + window.scrollY - 60, behavior: 'smooth' });
        }
      }
    }

    function result() {
      var scores = {};
      var total = 0;
      var factors = [];
      answers.forEach(function (a, i) {
        if (a.profile) scores[a.profile] = (scores[a.profile] || 0) + 1;
        var risk = a.count > 1 ? a.index / (a.count - 1) : 0;
        total += risk;
        factors.push({ label: questions[i].dataset.factor || '', value: risk });
      });
      var exposure = answers.length ? total / answers.length : 0;

      var winner = profiles[0] ? profiles[0].dataset.quizProfile : '';
      var best = -1;
      profiles.forEach(function (p) {
        var s = scores[p.dataset.quizProfile] || 0;
        if (s > best) {
          best = s;
          winner = p.dataset.quizProfile;
        }
      });

      return { profile: winner, exposure: exposure, factors: factors };
    }

    function render(data) {
      var panel = null;
      profiles.forEach(function (p) {
        var active = p.dataset.quizProfile === data.profile;
        p.hidden = !active;
        if (active) panel = p;
      });
      if (!panel) return;

      var value = panel.querySelector('[data-quiz-exposure]');
      var names = value ? [value.dataset.low, value.dataset.medium, value.dataset.high] : ['Low', 'Medium', 'High'];
      var level = levelOf(data.exposure);
      if (value) value.textContent = names[level] || '';
      panel.setAttribute('data-level', level + 1);

      // Bars: strongest risk first; keep a sliver visible for the lowest answers
      var chart = panel.querySelector('[data-quiz-chart]');
      var bars = [];
      if (chart) {
        chart.innerHTML = '';
        data.factors
          .filter(function (f) {
            return f.label;
          })
          .sort(function (a, b) {
            return b.value - a.value;
          })
          .forEach(function (f, i) {
            var li = document.createElement('li');
            li.className = 'sport-quiz__row' + (i === 0 ? ' sport-quiz__row--top' : '');
            var label = document.createElement('span');
            label.className = 'sport-quiz__row-label';
            label.textContent = f.label;
            var level = document.createElement('span');
            level.className = 'sport-quiz__row-level';
            level.textContent = names[levelOf(f.value)] || '';
            var track = document.createElement('span');
            track.className = 'sport-quiz__row-track';
            var bar = document.createElement('span');
            bar.className = 'sport-quiz__row-bar';
            track.appendChild(bar);
            li.appendChild(label);
            li.appendChild(level);
            li.appendChild(track);
            chart.appendChild(li);
            bars.push({ el: bar, width: Math.max(0.1, f.value) * 100 });
          });
      }

      var gauge = panel.querySelector('[data-quiz-gauge]');
      if (gauge) gauge.style.width = '0%';

      // Animate on the next frame so the widths transition from zero
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          bars.forEach(function (b) {
            b.el.style.width = b.width + '%';
          });
          if (gauge) gauge.style.width = Math.max(0.08, data.exposure) * 100 + '%';
        });
      });
      return panel;
    }

    function finish() {
      var data = result();
      show(steps.indexOf(resultStep), false);
      var panel = render(data);
      var title = panel && panel.querySelector('.sport-quiz__profile-title');
      if (title) title.focus({ preventScroll: true });
      var top = root.getBoundingClientRect().top;
      if (top < -40 || top > window.innerHeight * 0.3) {
        window.scrollTo({ top: top + window.scrollY - 60, behavior: 'smooth' });
      }
      track('sport_quiz_completed', {
        sport: sport,
        profile: data.profile,
        exposure: ['low', 'medium', 'high'][levelOf(data.exposure)]
      });
    }

    function start() {
      answers = [];
      root.querySelectorAll('[data-quiz-answer]').forEach(function (b) {
        b.removeAttribute('aria-pressed');
      });
      show(1, true);
      track('sport_quiz_started', { sport: sport });
    }

    function pick(answer) {
      if (locked) return;
      var step = answer.closest('[data-quiz-step]');
      var q = questions.indexOf(step);
      step.querySelectorAll('[data-quiz-answer]').forEach(function (b) {
        b.setAttribute('aria-pressed', b === answer ? 'true' : 'false');
      });
      answers[q] = {
        index: parseInt(answer.dataset.index, 10) || 0,
        count: parseInt(step.dataset.answerCount, 10) || 1,
        profile: answer.dataset.profile
      };
      answers.length = q + 1;
      locked = true;
      window.setTimeout(function () {
        locked = false;
        if (q + 1 < questions.length) {
          show(current + 1, true);
        } else {
          finish();
        }
      }, 320);
    }

    root.addEventListener('click', function (event) {
      var startBtn = event.target.closest('[data-quiz-start]');
      var answer = event.target.closest('[data-quiz-answer]');
      var back = event.target.closest('[data-quiz-back]');

      if (startBtn) {
        start();
      } else if (answer) {
        pick(answer);
      } else if (back) {
        show(Math.max(current - 1, 0), true);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.altKey) return;
      var tag = (event.target.tagName || '').toLowerCase();
      if (tag === 'input' || tag === 'textarea' || tag === 'select' || event.target.isContentEditable) return;
      if (!inView(root)) return;

      var step = steps[current];
      if (step.dataset.quizStep === 'intro' && event.key === 'Enter') {
        if (tag === 'button' || tag === 'a') return; // a focused control handles Enter itself
        event.preventDefault();
        start();
      } else if (step.dataset.quizStep === 'question' && /^[a-d]$/i.test(event.key)) {
        var answer = step.querySelector('[data-key="' + event.key.toLowerCase() + '"]');
        if (answer) {
          event.preventDefault();
          pick(answer);
        }
      }
    });

    show(0, false);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-sport-quiz]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
